module.exports = __webpack_public_path__ + "img/icon_5.1bdf522d.svg";